import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CookiesService {

    /**
     * Store a cookie
     *
     * @param cookieName
     * @param cookieValue
     * @param daysToExpiration
     **/
    public setCookie(cookieName: string, cookieValue: string|number, daysToExpiration: number) {

        const cookieExpirationDate = new Date();

        cookieExpirationDate.setTime(cookieExpirationDate.getTime() + (daysToExpiration*24*60*60*1000));

        document.cookie = cookieName + "=" + cookieValue + "; expires=" + cookieExpirationDate.toUTCString() + '; Path=/;';
    }

    /**
     * Function returns the value of a given cookie name or if the cookie is not found then it returns a blank string
     *
     * @param cookieName
     * @returns Value of cookie
     **/
    public getCookie(cookieName: string): string {

        const name = cookieName + "=";
        const cookiesArray = document.cookie.split(';');

        for(let i = 0; i < cookiesArray.length; i++) {
            let cookie = cookiesArray[i];
            while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
            if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
        }

        return "";
    }

    /**
     * Function removes the cookie by setting the expires parameter to a past date
     *
     * @param cookieName
     **/
    public removeCookie(cookieName:string) {
        document.cookie = cookieName +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}
